import { render, staticRenderFns } from "./rewardAndPubishRecord.vue?vue&type=template&id=3172d81c&"
import script from "./rewardAndPubishRecord.vue?vue&type=script&lang=js&"
export * from "./rewardAndPubishRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "rewardAndPubishRecord.vue"
export default component.exports